// UI-хелперы: нативные Telegram-попапы вместо браузерного alert().

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function tg(): any {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (window as any).Telegram?.WebApp;
}

/** Нативный Telegram-алерт с фолбэком на браузерный alert(). */
export function notify(message: string): void {
  const w = tg();
  if (w?.showAlert) {
    try {
      w.showAlert(message);
      return;
    } catch {
      /* fallthrough на alert */
    }
  }
  // eslint-disable-next-line no-alert
  alert(message);
}

/** Нативный Telegram-конфирм (да/нет). Возвращает Promise<boolean>. Фолбэк — window.confirm. */
export function confirmAction(message: string): Promise<boolean> {
  const w = tg();
  if (w?.showConfirm) {
    return new Promise((resolve) => {
      try {
        w.showConfirm(message, (ok: boolean) => resolve(!!ok));
      } catch {
        // eslint-disable-next-line no-alert
        resolve(window.confirm(message));
      }
    });
  }
  // eslint-disable-next-line no-alert
  return Promise.resolve(window.confirm(message));
}

/** Показывает текст ошибки (Error | строка) нативным попапом. */
export function notifyError(e: unknown): void {
  notify(e instanceof Error ? e.message : String(e));
  try {
    tg()?.HapticFeedback?.notificationOccurred?.("error");
  } catch {
    /* haptics необязательны */
  }
}
